import angular from 'angular';

export const CORE_MODULE = 'app.core';

angular.module(CORE_MODULE, []);

export default CORE_MODULE;
